export const ADULT_AGE = 18;

export const isAdultAge = (age: number): boolean => age >= ADULT_AGE;
